import { DEFAULT_FLOWCODE_NICKNAME } from '@dtx-company/app/shared/code/src/constants/flowcode'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { matchesAnyRoute, matchesRoute } from '@dtx-company/true-common/src/utils/urls/matchesRoute'

/* Returns the page title of the mobile top nav
  Undefined if new top nav is not mounted */
export const getMobileV3NavTitle = (args: {
  pathname: string
  codeNickname?: string | undefined
  batchId?: string | string[] | undefined
  pageSlug?: string | undefined
  t: (_: string) => string
}): string | undefined => {
  const { pathname, codeNickname, batchId, pageSlug, t } = args
  // NOTE: use matchesRoute (not exact ===) because callers pass the resolved
  // pathname from next/navigation's usePathname() (e.g. `/codes/abc123`), not
  // the Pages Router pattern (`/codes/[batchId]`). An exact switch silently
  // returned undefined for every dynamic route, blanking the mobile top nav.
  if (matchesRoute(pathname, Routes.CODE)) {
    if (batchId) {
      return codeNickname?.length ? codeNickname : DEFAULT_FLOWCODE_NICKNAME
    }
    return t('Titles.Assets')
  }
  if (matchesAnyRoute(pathname, [Routes.PAGES, Routes.TRASH, Routes.CODES, Routes.ASSETS])) {
    return t('Titles.Assets')
  }
  if (matchesAnyRoute(pathname, [Routes.CREATE_FLOWCODE, Routes.CREATE_FLOWCODE_V3])) {
    return t('Titles.CreateFlowcode')
  }
  if (matchesRoute(pathname, Routes.ACCOUNT)) {
    return t('Titles.Account')
  }
  if (matchesRoute(pathname, Routes.EDIT_CODE)) {
    return t('Titles.EditCode')
  }
  if (matchesRoute(pathname, Routes.FOLDERS)) {
    return t('Titles.Folders')
  }
  if (matchesRoute(pathname, Routes.ARCHIVE_ASSETS)) {
    return t('Titles.Archive')
  }
  if (
    matchesAnyRoute(pathname, [
      Routes.MY_ORG_TEAMS,
      Routes.MY_ORG_MEMBERS,
      Routes.MY_ORG_TEAM,
      Routes.MY_ORG_INVITATIONS
    ])
  ) {
    return t('Titles.Teams')
  }
  if (matchesRoute(pathname, Routes.DOMAINS)) {
    return t('Titles.Domains')
  }
  if (matchesAnyRoute(pathname, [Routes.PAGE_EDITOR, Routes.PAGE_TEMPLATE_EDITOR])) {
    return pageSlug?.length ? pageSlug : t('Titles.PageEditor')
  }
  if (matchesRoute(pathname, Routes.ANALYTICS)) {
    return t('Titles.Dashboard')
  }
  if (matchesRoute(pathname, Routes.ANALYTICS_CODES)) {
    return t('Titles.FlowcodeAnalytics')
  }
  if (matchesAnyRoute(pathname, [Routes.ANALYTICS_PAGE, Routes.ANALYTICS_PAGES])) {
    return t('Titles.FlowpageAnalytics')
  }
  if (matchesRoute(pathname, Routes.ANALYTICS_CONVERSIONS)) {
    return t('Titles.ConversionAnalytics')
  }
  if (matchesRoute(pathname, Routes.ANALYTICS_EVENTS)) {
    return t('Titles.FlowlyticsEvents')
  }
  if (matchesRoute(pathname, Routes.ANALYTICS_INSIGHTS)) {
    return t('Titles.FlowlyticsInsights')
  }
  if (matchesRoute(pathname, Routes.SEARCH_RESULTS)) {
    return t('Titles.SearchResults')
  }
  if (matchesRoute(pathname, Routes.HOME)) {
    return t('Titles.Home')
  }
  return undefined
}
